import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=9c7a1150&scoped=true&"
import script from "./TagsInput.vue?vue&type=script&lang=js&"
export * from "./TagsInput.vue?vue&type=script&lang=js&"
import style0 from "./TagsInput.vue?vue&type=style&index=0&id=9c7a1150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7a1150",
  null
  
)

export default component.exports